import React from 'react'
import Simplert from 'react-simplert'
import Helmet from 'react-helmet'
import axios from 'axios'
import Input from '../components/newInput/input'
import Button from '../components/newButton/button'
import Navbar from '../components/newNavbar/navbar'
import '../style/pages/phoneverify.scss'
import Loading from '../components/loading/loading'
import ErrorM from '../components/ErrorMessange/errormenssage'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import { GraphQLClient } from 'graphql-request'
import { endpoint, tokensms } from '../queries/endpoint'
import ErrorBroundray from '../components/errorBoundary/errorBoundary'

export default class anuncios extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            showAlert: false,
            typeAlert: '',
            titleAlert: '',
            messageAlert: '',
            onClose: null,
            playerId: "",
            customCloseBtnText: 'Fechar',
            customCloseBtnClass: 'buttonnot', // colocar cor roxa
            loading: false,
            phoneOk: false,
            phoneErr: null,
            idConfirm: null,
            end: false,
            value: null,
            phonen: null
        }

        this.form = {}

        this.phoneMask = e => {
            let phoneMasked = e.target.value;
            this.form['phone'] = phoneMasked
            console.log(this.form.phone)
            if (!phoneMasked.match(/_/)) this.setState({ phoneOk: true, phoneErr: null, phonen: phoneMasked })
            else if (phoneMasked !== "(__) _____-____" && !phoneMasked.match(/_/)) this.setState({ phoneOk: false, phoneErr: <ErrorM color="danger" content='Digite somente números. DDD com 2 digitos e seu celular com 9 digitos.' /> })
            return (e.target.value = this.form.phone);
        }; //_phoneMask

        this.verify = e => {
            console.log("chamando verificacao ")

            if (this.state.value === null) {
                this.setState ({ value: this.form.phone })
            }

            const number = this.state.phonen === null ? this.form.phone : this.state.phonen

            console.log(number)
            this.setState({ loading: true })
            e.preventDefault()
            this.form.pin = ""
            const verication = {
                numero_destino: number.replace("(", "").replace(")", "").replace(" ", "").replace("-", "").replace("+55", ""),
                nome_produto: "Oito App",
                tamanho: "6",
                tts: false
            }
            axios.post('https://api2.totalvoice.com.br/verificacao', verication, {
                headers: {
                    "Content-Type": "application/json",
                    "Access-Token": tokensms
                }
            }).then(
                res => {
                    // console.log(res.data.dados.id)
                    if (res.status === 200) {
                        this.setState({ idConfirm: res.data.dados.id, loading: false, end: true, phonen: number })
                    } else {
                        this.setState({ loading: false, phoneErr: <ErrorM color="danger" content='Ocorreu algum erro. Verifique seu número e tente novamente.' /> })
                    }
                }
            ).catch(
                err => {
                    console.log(err)
                    this.setState({ loading: false, phoneErr: <ErrorM color="danger" content='Ocorreu algum erro. Verifique seu número e tente novamente.' /> })
                }
            )
        }

        this.confirm = e => {
            e.preventDefault()
            console.log("confirmando verificacao")
            this.setState({ loading: true })

            axios.get(`https://api.totalvoice.com.br/verificacao/?id=${this.state.idConfirm}&pin=${this.form.pin}`, {
                headers: {
                    "Content-Type": "application/json",
                    "Access-Token": tokensms
                }
            }).then(
                res => {

                    if (res.status === 200) {
                        // console.log(res)

                        // query confirm phone
                        const cache = JSON.parse(sessionStorage.getItem('OITO'))
                        // console.log(cache)
                        if (cache) {
                            const client = new GraphQLClient(endpoint, {
                                headers: {
                                    Authorization: `Bearer ${cache.token}`,
                                },
                            })

                            client.request(`
                            mutation{
                                updateUser(input:{
                                    phone: "${this.state.phonen}"
                                    phoneverif: true
                                }){
                                    id
                                    name
                                    birthday
                                    phone
                                    type
                                    email
                                    description
                                    photo
                                    role
                                    phoneverif
                                    address {
                                    city
                                    state
                                    street
                                    zipcode
                                    number
                                    complement
                                    neighborhood
                                    country
                                    }                   
                                }
                            } `).then(
                                res => {
                                    console.log(res)
                                    const cache = JSON.parse(sessionStorage.getItem('OITO'))
                                    console.log("atualizando o storage")
                                    const userAuth = {
                                        token: cache.token,
                                        user: res.updateUser
                                    }

                                    sessionStorage.setItem('OITO', JSON.stringify(userAuth))

                                    this.setState({
                                        showAlert: true,
                                        typeAlert: 'success',
                                        titleAlert: 'Telefone verificado com sucesso!',
                                        messageAlert: ``,
                                        loading: false,
                                        onClose: () => window.location.href = '/perfil',
                                    })
                                    // console.log(sessionStorage)
                                }
                            ).catch(
                                err => {
                                    console.log(err)
                                    this.setState({ loading: false, phoneErr: <ErrorM color="danger" content='Ocorreu algum erro. Verifique seu número e tente novamente.' /> })
                                }
                            )
                        }
                    } else {
                        this.setState({ loading: false, phoneErr: <ErrorM color="danger" content='Ocorreu algum erro. Verifique seu número e tente novamente.' /> })
                    }
                }
            ).catch(
                err => {
                    console.log(err)
                    this.setState({ loading: false, phoneErr: <ErrorM color="danger" content='Ocorreu algum erro. Verifique seu número e tente novamente.' /> })
                }
            )
        }
    }

    render() {
        const cache = JSON.parse(sessionStorage.getItem('OITO'))

        if (cache) {
            this.form.phone = cache.user.phone
            this.playerId = cache.user.id
            this.name = cache.user.name
            if (this.form.phone && !this.state.phoneOk) {
                if (this.form.phone.replace("(", "").replace(")", "").replace(" ", "").replace("-", "").replace("+55", "").length === 11) this.setState({ phoneOk: true })
            }
            // if (cache.user.player.phoneverif) window.location.href ='/perfil'

        } else {
            window.location.href = '/login'
        }

        const LastURL = JSON.parse(sessionStorage.getItem('LastURL'))
        if (LastURL) {

            if (LastURL.path !== window.location.pathname) {
                const listHistory = {
                    count: parseInt(LastURL.count) - 1,
                    path: window.location.pathname
                }

                sessionStorage.setItem('LastURL', JSON.stringify(listHistory))

            }
        }

        return (
            <div className="content">
                <Helmet title='Oito - Verificar o celular'>
                    <meta name="description" content="Complete seu cadastro em Oito.app com dados pessoais e habilidades e encontre clientes que buscam por seus serviços." />
                    <meta name="keywords" content="Cadastro, Oportunidades, Serviços" />
                    <meta name="robots" content="index, follow" />
                    <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
                    <meta name="language" content="Portuguese" />
                    <meta name="revisit-after" content="1 days" />
                </Helmet>

                <ErrorBroundray><Navbar /></ErrorBroundray>

                <div id="phoneferify">
                    <div className="form-register-box container">
                        <div className="form-title col-12">
                            <h1>Oi, <span>{this.name.split(' ')[0]}</span>. Agora vamos verificar seu número.</h1>
                            <p>É necessário que esteja com seu celular em mãos e com sinal. Para verificar seu número iremos enviar uma mensagem SMS, sem nenhum custo.</p>
                        </div>
                        <div className="form-container col-12 align-items-center justify-content-center">
                            {this.state.end ? <p>Confirmação enviada para: {this.state.phonen}</p> : null}
                            
                            {this.state.loading ? <Loading /> : null }

                            <div className="col-10 col-sm-6 col-md-4 input-phoneverify">
                            {/* <form id="myForm"> */}
                                {!this.state.end ?
                                    <form id="myForm">
                                        <Input name="phone" label="Telefone celular" placeholder="Ex.: (xx) xxxxx-xxxx" type="text" defaultValue={this.form.phone} mask="(99) 99999-9999" onChange={(e) => this.phoneMask(e)} required />
                                        <OverlayTrigger
                                            placement='right'
                                            overlay={<Tooltip id="pqphone">A Oito necessita de um número de telefone válido para facilitar o contato entre clientes e prestadores de serviço. Simbolos serão inseridos automaticamente. Certifique-se de que o número esteja correto e no formato solicitado.</Tooltip>} >
                                            <i className="fas fa-info"></i>
                                        </OverlayTrigger><br />
                                        { this.state.phoneErr ? this.state.phoneErr : null}
                                        <Button type="submit" onClick={this.verify} className={this.state.phoneOk ? null : 'disable'} name={'Verificar'} />
                                        </form>
                                    :
                                    <form id="myForm">
                                        <Input name="pin" label="Código de confirmação" placeholder="Ex.: 123456" type="text" onInput={(e) => this.form.pin = e.target.value} required maxLength={6} pattern="[0-9]{6}"/>
                                        <OverlayTrigger
                                            placement='right'
                                            overlay={<Tooltip id="pqpin">Você irá receber uma mensagem de SMS com um código. Digite-o aqui e clique em enviar. Caso não receba, aguarde alguns instantes, verifique se o número digitado está correto, se o anti-spam de SMS está destivado e se seu aparelho tem sinal.</Tooltip>} >
                                            <i className="fas fa-info"></i>
                                        </OverlayTrigger><br />
                                        { this.state.phoneErr ? this.state.phoneErr : null}
                                        <Button type="submit" onClick={this.confirm} className={this.form.pin ? this.form.pin.length === 6 ? null : 'disable' : 'disable'} name={'Enviar'} />
                                    </form>
                                }

                                {/* <div style={{ display: 'flex', justifyContent: 'center' }}>
                                    {this.state.loading ? <Loading />
                                        : !this.state.end ?
                                            <Button type="submit" onClick={this.verify} className={this.state.phoneOk ? null : 'disable'} name={'Verificar'} />
                                            : <Button type="submit" onClick={this.confirm} className={this.form.pin ? this.form.pin.length === 6 ? null : 'disable' : 'disable'} name={'Enviar'} />
                                    }
                                </div> */}
                            {/* </form> */}
                            </div> 
                        </div>
                    </div>
                    <Simplert
                        showSimplert={this.state.showAlert}
                        type={this.state.typeAlert}
                        title={this.state.titleAlert}
                        message={this.state.messageAlert}
                        customCloseBtnText={this.state.customCloseBtnText}
                        customCloseBtnClass={this.state.customCloseBtnClass}
                        onClose={this.state.onClose}
                    />
                </div>
            </div>
        )
    }
}
